import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function DiscardDialog({ open, data, handleClose, itemDialog, setItemDialog }) {
    const [price, setPrice] = useState()
    useEffect(() => {
        setPrice(+itemDialog?.find((x) => x?.ItemNo === data?.ItemNo?.ItemNo)?.lots[0]?.SalePrice)
    }, [data])

    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                เมล็ดพันธุ์คัดออก
            </DialogTitle>
            <DialogContent>
                <h6>{data?.ItemNo?.ItemName} {data?.ItemNo?.Option2} <span style={{ color: data?.Season === 'ฝน' ? '#0D9206' : 'brown' }}> {data?.Season}</span>  {data?.ItemNo?.Option1}</h6>
                <span style={{ color: "#FFA101" }}>
                    ปริมาณคงเหลือในโรงเก็บ {data?.Balance} กิโลกรัม
                </span>
                <Box className='backgroundField' sx={{ margin: '10px 0' }}>
                    <TextField value={price || ''} onChange={(e) => setPrice(e.target.value)} variant="standard" fullWidth placeholder='ราคา / กิโลกรัม'
                        InputProps={{
                            disableUnderline: true,
                        }}
                        onKeyPress={(event) => {
                            if (!/[0-9-.]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose}>ปิด</Button>
                <Button variant='contained' onClick={() => {
                    const item = {
                        ...data.ItemNo,
                        lots: [{
                            ...data.ItemNo,
                            SalePrice: +price,
                            Qty: data?.Balance,
                            UnitNo: data?.UnitNo,
                            WarehouseNo: data?.WarehouseNo,
                            ZoneNo: data?.ZoneNo,
                            Lot: data?.Lot
                        }]
                    }
                    const body = itemDialog?.find((x) => x?.ItemNo === data?.ItemNo?.ItemNo) ? itemDialog?.map((x, i) => {
                        x.lots = x?.ItemNo === data?.ItemNo?.ItemNo ? x?.lots?.map((y) => {
                            return {
                                ...y,
                                SalePrice: price,
                            }
                        }) : x?.lots
                        return x
                    }) : [...itemDialog, item]
                    setItemDialog(body)
                    handleClose()
                    setPrice()
                }}>
                    ตกลง
                </Button>
            </DialogActions>
        </Dialog>
    )
}
